import { useCallback, useState } from "react";

type State = {};
type Update = () => void;
export function useForceUpdate(): [State, Update] {
    const [force, updateState] = useState({});
    const forceUpdate = useCallback(() => updateState({}), []);
    return [force, forceUpdate];
}